/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <br><br>
  <div>
  <div class="formPosition">
           <v-card style="margin:auto;" width="1000px" height="600px">

              <template >

                  <v-toolbar color="#006699" style="color:white;">

           <v-row>
                    <v-col sm="4" cols="12" md="4">

                </v-col>

                  <v-col sm="4" cols="12" md="6">  <!--  form titlte section   {{ formTitle }}-->
                <span style="font-size:20px;">Pagamento de Propinas</span>

                  </v-col>

          </v-row>

                  </v-toolbar>

              </template>
 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                   <v-row>
                    <v-col cols="12" md="12">
                       <v-autocomplete
                          v-model="editedItem.estudante"
                          :items="estudantes"
                          :loading="isLoading_"
                          :search-input.sync="search"
                          color="primary"
                          item-text="nome"
                          item-value="nome"
                          label="Nome do estudante"
                          placeholder="Digite o nome do estudante"
                          prepend-icon="mdi-database-search"
                          return-object
                          @change="SelectedEstudante"
                        ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                     <v-col cols="12" md="10">
                         <v-progress-linear
                         v-if="progresso_pesquisa"
                        color="green accent-4"
                        indeterminate
                        rounded
                        height="6"
                      ></v-progress-linear>
                     </v-col>
                  </v-row>
                   <v-row>
                     <v-col cols="12" md="4">
                         <v-text-field
                         :disabled="true"
                         v-model="estudante"
                         label="Número de Matricula"
                       ></v-text-field>
                     </v-col>
                     <v-col cols="12" md="4">
                         <v-text-field
                         :disabled="true"
                         v-model="nome_pai"
                         label="Nome do Pai"
                       ></v-text-field>
                     </v-col>
                     <v-col cols="12" md="4">
                         <v-text-field
                         :disabled="true"
                         v-model="nome_mae"
                         label="Nome da Mãe"
                       ></v-text-field>
                     </v-col>
                     <v-col cols="12" md="3">
                        <v-text-field
                         :disabled="true"
                         v-model="mesReferente"
                         label="Mês Referente"
                       ></v-text-field>
                     </v-col>
                     <v-col cols="12" md="4">
                        <v-text-field
                         :disabled="true"
                         v-model="valorApagar"
                         label="Valor a Pagar"
                       ></v-text-field>
                     </v-col>

                      <v-col cols="12" md="5">
                        <v-combobox
                           :rules="ruleRequired"
                            chips
                            v-model="reciboSelected"
                            @change="loadValorRecibo()"
                            :items="recibos_filtered"
                            item-text="num_recibo"
                            :disabled="disabilita"
                          label="Recibo a ser descontado"
                      ></v-combobox>
                     </v-col>

                     <v-col cols="12" md="4">
                       <v-text-field
                         :disabled="true"
                         v-model="valorRecibo"
                         label="Valor do Recibo"
                       ></v-text-field>
                     </v-col>
                     <v-col md="4"></v-col>
                    <v-col md="5"></v-col>
                    <v-col md="2">
                        <v-btn    :disabled="!valid"     color="success"    @click="save">Submeter</v-btn>

                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

</v-form>

            </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    novo: false,
    progresso: false,
    progresso_: false,
    progresso_pesquisa: false,
    dialog_associar_recibos: false,
    mensagem: false,
    disabilita: false,
    numero_recibo: '',
    somaRecibo_Descricao: '',
    valorApagarNumerico: 0,
    valorApagar: '',
    somaRecibo: 0,
    quantidade_recibos: 0,
    conta_bancaria: 0,
    associar_recibo: false,
    valid: true,
    ano_actual: ls.get('anolectivo'),
    startDate: null,
    isLoading_: false,
    isLoading: false,
    servico: '',
    cor: '',
    search: '',
    searchInDb: '',
    mesReferente: null,
    servicoSelected: null,
    reciboSelected: null,
    valorRestanteRecibo: '',
    valor_a_pagar: '',
    pesquisa: '',
    estudante: null,
    nome_mae: '',
    nome_pai: '',
    preco: 0,
    precosPropina: [],
    multas: [],
    pagamentos: [],
    recibos_estudante: [],
    recibos_filtered: [],
    estudantes: [],
    recibos: [],
    precos: [],
    servicos: [],
    valorFormatado: '',
    valorRecibo: '',
    valorReciboNumerico: 0,
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    headers: [
      {
        text: 'Nome do Serviço',
        align: 'left',
        sortable: false,
        value: 'servico'
      },

      { text: 'Preço', value: 'preco' },
      { text: 'Autor', value: 'autor' },
      { text: 'data cadastro', value: 'data_' }
    ],
    msg: '',
    editedIndex: -1,
    editedItem: {

      estudante: null

    }

  }),

  computed: {

    loggedUserName () {
      return ls.get('nomeUsuario')
    },

    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    search (val) {
      // Items have already been loaded
    // this.estudantes = []
      // console.log('passouuuuuu' + this.estudantes.length)

      if (val.length >= 4) {
      // Items have already been requested
        if (!this.estudantes.filter(t => t.nome.includes(val)).length) {
          this.estudantes = []
          return this.Pesquisar(val)
        }
      }

      if (val.length >= 4) { return this.Pesquisar(val) }
    }

  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeRecibos()
    this.initializeMultas()
    this.initializePrecoPropina()
  },

  methods: {
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL

    async initializeRecibos (searchInDb) {
      try {
        //   let  payload =""

        this.isLoading = true
        this.recibos = await axios
          .get('/recibosFindAll')
          .then(res => res.data)
        console.log(this.recibos)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializePrecoPropina () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.precosPropina = await axios
          .get('/precoPropinasFindAll')
          .then(res => res.data)
        console.log(this.precosPropina)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeMultas () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.multas = await axios
          .get('/ListarMultasExistentes')
          .then(res => res.data)
        console.log(this.multas)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async  AssociarRecibos () {
      try {
        //   let  payload =""

        this.progresso_ = true
        this.recibos_estudante = await axios
          .get('/recibosFind/' + this.editedItem.estudante.pk_estudante)
          .then(res => res.data)
        this.progresso_ = false
        if (this.recibos_estudante.length) {
          this.quantidade_recibos = this.recibos_estudante.length
          this.associar_recibo = true
          this.SomarValorRecibos(this.recibos_estudante)
        }
      } catch (error) {
        this.progresso_ = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeServicosPrecos () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.precos = await axios
          .get('/ServicosPrecoFindAll')
          .then(res => res.data)
        console.log(this.precos)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializePagamentosEstudante () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.pagamentos = await axios
          .get('/PagamentosEstudante/' + this.editedItem.estudante.pk_estudante)
          .then(res => res.data)
        console.log(this.pagamentos)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async CriarReciboAssociado () {
      let estudantes = []
      estudantes.push(this.editedItem.estudante)
      let params =
        {
          pk_recibo: 0,
          fk_est: estudantes,
          formaPagamento: 'Associado',
          conta: this.conta_bancaria,
          valor: this.somaRecibo,
          data_recibo: new Date(),
          autor: ls.get('nomeUsuario'),
          recibo: this.numero_recibo,
          valor_descr: this.somaRecibo_Descricao + 'Akz'
        }
      try {
        let corMensagem = 'msgError'
        let result = await axios
          .post('/ReciboInsertOrUpdate', params)
          .then(res => res.data)
        if (result != null) {
          if (result.affectedRows > 0) {
            this.recibos_estudante.forEach(element => {

            })
          }
        }

        this.progresso = false
      } catch (erro) {

      }
    },

    SomarValorRecibos (recibos) {
      let comprovativo = '00A'
      let soma = 0
      let conta = 0
      recibos.forEach(element => {
        soma += element.valor
        comprovativo = comprovativo.concat('-', element.num_recibo)
        conta = element.pk_conta_bancaria
      })
      this.somaRecibo = soma
      this.somaRecibo_Descricao = this.ObterValorFormatado(this.somaRecibo)
      this.numero_recibo = comprovativo
      this.conta_bancaria = conta
    },

    SelectedEstudante () {
      if (this.editedItem.estudante !== null) { // Set campos
        this.estudante = this.editedItem.estudante.nome
        this.nome_pai = this.editedItem.estudante.pai
        this.nome_mae = this.editedItem.estudante.mae
        this.initializePagamentosEstudante().then(() => {
          if (this.pagamentos.length) {
            this.mesReferente = this.pagamentos[0].nome
          }
        })
        // Filtra o recibo do estudante
        this.recibos_filtered = this.recibos.filter(r => r.estudante_pk_estudante === this.editedItem.estudante.pk_estudante)
        // Filtra o valor da propina
        let dados = this.precosPropina.filter(p => p.fk_classe === this.editedItem.estudante.fk_classe && p.status_definir_precario_propina === 1)
        if (dados.length) {
          this.valorApagar = dados[0].valor_descricao
          this.valorApagarNumerico = dados[0].preco
        }
      }
    },

    VerificaExistenciaMulta () {
      let m = this.multas.filter(m => m.fk_classe === this.editedItem.estudante.fk_classe && m.fk_mes === this.pagamentos[0].pk_mes)
      if (m.length) {
        if (this.reciboSelected.mes_recibo === this.pagamentos[0].pk_mes) {
          let diaRecibo = parseInt(this.reciboSelected.data_recibo.split('-')[2])
          console.log(diaRecibo)
        }
      }
    },

    loadValor () {
      let precoServico = this.precos.filter(p => p.fk_outros_servicos === this.servicoSelected.pk_outros_servicos)
      if (precoServico.length) {
        this.valor_a_pagar = precoServico[0].preco + ' Akz'
        this.disabilita = false
      } else {
        this.disabilita = true
        this.text = 'Este serviço não tem um preço associado , por favor cadastre um preço ao serviço.'
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 4000 })
        this.valor_a_pagar = ''
      }
      this.LimparCampos()
    },

    editar () {
      // this.bancoSelected = this.editedItem.nome
      // this.preco = this.editedItem.numero_conta
      this.novo = true
    },

    LimparCampos () {
      // eslint-disable-next-line no-unused-expressions
      this.reciboSelected = null
      this.valorRecibo = ''
      this.valorRestanteRecibo = ''
    },

    loadValorRecibo () {
      if (this.reciboSelected !== null) {
        if (this.valorApagarNumerico <= this.reciboSelected.valor) {
          this.valorRecibo = this.reciboSelected.valor_descricao
          this.VerificaExistenciaMulta()
        } else {
          this.valid = false
          this.text = 'O valor do recibo selecionado é inferior ao valor da Mensalidade!'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 4000 })
        }

        // this.VerificaExistenciaMulta()
        /*  this.ObterValorFormatado(this.reciboSelected.valor)

        let valorAPagar1 = this.valor_a_pagar.replace(',00 Akz', '')
        let valorAPagarInteiro = parseInt(valorAPagar1.replace('.', ''))
        let valorReciboInteiro = parseInt(this.reciboSelected.valor)
        if (valorReciboInteiro >= valorAPagarInteiro) {
          let resultadoSubtracao = valorReciboInteiro - valorAPagarInteiro
          let valorFormatado = this.ObterValorFormatado(resultadoSubtracao)
          this.valorRecibo = valorFormatado + ' Akz'
        } */

        console.log(this.reciboSelected)
      }
    },

    chamaDialogo () {
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      return formated.toString().replace('AOA', '')
    },

    async Pesquisar (valor) {
      try {
        this.progresso_pesquisa = true
        this.isLoading_ = true
        this.estudantes = await axios
          .get('/PesquisaEstudanteRecibo/' + valor)
          .then(res => res.data)

        this.progresso_pesquisa = false
        this.isLoading_ = false
      } catch (error) {
        this.progresso_pesquisa = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    /*  async Pesquisar () {
      try {
        this.progresso_pesquisa = true
        let result = await axios
          .get('/PesquisaEstudanteRecibo/' + this.pesquisa)
          .then(res => res.data)

        this.progresso_pesquisa = false
        if (result.length) {
          this.mensagem = false
          this.estudante = result[0].nome
          this.nome_pai = result[0].pai
          this.nome_mae = result[0].mae
        } else {
          this.mensagem = true
        }
      } catch (error) {
        this.progresso_pesquisa = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, */

    async save () {
      if (this.$refs.form.validate()) {
        this.progresso = true
        this.ObterValorFormatado(this.preco)

        let params =
        {
          pk_outros_servicos_preco: 0,
          servico: this.servicoSelected.pk_outros_servicos,
          preco: this.valorFormatado.toString().trim()
        }

        try {
          let corMensagem = 'msgError'
          let msg = await axios
            .post('/precoServicoInsertOrUpdate', params)
            .then(res => res.data)
          this.progresso = false

          if (msg.length) {
            corMensagem = 'msgError'
            this.text = 'Ocorreu um erro ao tentar efectuar a operação'
          } else {
            corMensagem = 'msgSucess'
            this.text = 'Operação efectuada com sucesso'
            this.close()
          }
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 5000 })
        } catch (error) {
          this.progresso = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    }

  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
